import { useContext } from 'react';

import { TranslationsContext } from '../contexts/translations-context';
import { Formatter } from '../utils/formatter/formatter.utils';

export const useFormatter = () => {
   const translationsContext = useContext(TranslationsContext);
   return new Formatter(translationsContext.locale);
};
